import axios from "axios";
import env from "../variables/EndpointEnvironment";

const ContactAPI = () => {
  return axios.get(`${env.HOST}/kontak`);
};

export default ContactAPI;